import React from 'react'
import { GridCell } from 'common-controls/Core/index'

export function LayoutHeader (props) {
  const { children, blue } = props
  const color = blue ? 'blue' : 'teal'

  return (
    <GridCell shrink className={`slide-pane-head-${color}`}>
      {children}
    </GridCell>
  )
}

export default LayoutHeader
